export function ScheduleCtrl ($state, $scope, $translate, messages, Schedule, groups, schedule) {
  $scope.Schedule = new Schedule(null, groups);
  $scope.schedule = schedule;

  $scope.loaded       = true;
  $scope.showDefaults = true;

  $scope.Schedule.configureSchedule($scope.schedule);

  $scope.mechanics = $scope.Schedule.filterMechanicGroup($scope.schedule);

  $scope.editTimesheet = function (date, mechanicId, timesheet) {
    $scope.Schedule.editTimesheet(date, mechanicId, timesheet)
    .then( data => {
      messages.show(data, 'success');
      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.getGroup = function (request) {
    $scope.Schedule[request]();
    $scope.mechanics = $scope.Schedule.filterMechanicGroup($scope.schedule);
  };

  $scope.getSchedule = function (request) {
    $scope.Schedule[request]($scope.showDefaults)
    .then( data => {
      $scope.schedule = data;
      $scope.Schedule.configureSchedule($scope.schedule);
      $scope.mechanics = $scope.Schedule.filterMechanicGroup($scope.schedule);
    })
    .catch( err => {
      messages.error(err);
    });
  };

  $scope.createHoliday = function () {
    $scope.Schedule.createHoliday()
    .then( () => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SCHEDULE'), 'success');
      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.manageHolidays = function () {
    $scope.Schedule.manageHolidays()
    .then( () => {
      $state.reload();
    })
    .catch( err => {
      messages.error(err);

      $state.reload();
    });
  };

  $scope.setUnavailableTimes = function () {
    $scope.Schedule.setUnavailableTimes()
    .then(() => {
      $state.reload();
    });
  };

  $scope.toggleDefaults = function () {
    $scope.showDefaults = !$scope.showDefaults;

    $scope.Schedule.toggleDefaults($scope.showDefaults)
    .then( data => {
      $scope.mechanics = $scope.Schedule.filterMechanicGroup(data);
    })
    .catch( err => {
      messages.error(err);
    });
  };
}